import { cx } from "@linaria/core";

import * as styles from "./styles";

type Props = {
  inversed?: boolean;
  vertical?: boolean;

  size?: number;
  color?: string;
  lineWidth?: number;

  className?: string;
};

export function Chevron({
  className,
  vertical,
  inversed,
  size,
  lineWidth,
  color,
}: Props): React.JSX.Element {
  return (
    <span
      className={cx(
        className,
        styles.chevronCls,
        inversed && "inversed",
        vertical && "vertical"
      )}
      style={{
        // @ts-expect-error Poor typings
        "--size": size !== undefined ? `${size}px` : undefined,
        "--pythagoreanSize": size !== undefined ? `${Math.sqrt(size ** 2 * 2)}px` : undefined,
        "--line-width": lineWidth !== undefined ? `${lineWidth}px` : undefined,
        "--line-color": color
      }}
    >
      <span
        className={cx(
          vertical ? styles.verticalLineCls : styles.horitzontalLineCls,
          "upper"
        )}
      />
      <span
        className={cx(
          vertical ? styles.verticalLineCls : styles.horitzontalLineCls,
          "lower"
        )}
      />
    </ span>
  );
}
